    <div class="container-fluid">
        <div class="row mt-4">
            <div class="col">
                <h5 class="blue"><i class="fas fa-pencil-alt"></i>&nbsp;Editar almacén</h5>
            </div>
        </div>
        <hr>
        <form #formNuevoAlmacen="ngForm" (ngSubmit)="formSubmit(formNuevoAlmacen)" novalidate="">
            <div class="container-fuid" style="height: 460px; overflow-y: auto; padding-right: 20px; overflow-x: hidden;">
                <div class="row">
                    <div class="col col-6">
                        <label class="form-label">Estación:</label>
                        <br>
                        <p-dropdown name="slcEstaciones" #slcEstaciones="ngModel" [options]="estaciones" [filter]="true" filterBy="label" [style]="{'width':'100%'}" 
                        [(ngModel)]="AlmacenRQ.idEstacion" optionLabel="label" optionValue="value" [required]="true"></p-dropdown>
                    </div>

                    <div class="col col-6">
                        <label class="form-label">Tipo de Combustible:</label>
                        <br>
                        <p-dropdown name="slcCombustibles" #slcCombustibles="ngModel" [options]="combustibles" [filter]="true" filterBy="label" [style]="{'width':'100%'}" 
                        [(ngModel)]="AlmacenRQ.idCombustible" optionLabel="label" optionValue="value" ></p-dropdown>

                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col col-12">
                        <label class="form-label">Estatus:</label>
                        <br>
                        <p-dropdown name="slcEstatus" #slcEstatus="ngModel" [options]="estatusCatalog" [filter]="true" filterBy="label" [style]="{'width':'100%'}" 
                        [(ngModel)]="AlmacenRQ.idEstatus" optionLabel="label" optionValue="value" [required]="true"
                        placeholder="Selecciona un estatus"></p-dropdown>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col col-12">
                        <div class="form-group">
                            <label class="form-label">Descripción:</label>
                            <textarea autocomplete="off" class="form-control form-control-sm custom-input" placeholder="Descripción" 
                            name="txtDescripcion" #txtDescripcion="ngModel" [rows]="2" [(ngModel)]='AlmacenRQ.descripcion' pattern="^[a-zA-Z0-9À-ÿñÑ\s]{2,}$" required></textarea>

                        </div>
                    </div>
                </div>
               

                <div class="row mt-3">
                    <div class="col col-6">
                        <label class="form-label">Site:</label>
                        <input type="text" autocomplete="off" class="form-control form-control-sm custom-input" placeholder="Site" name="txtSite" #txtSite="ngModel" [(ngModel)]='AlmacenRQ.idSite' maxlength="30" pattern="^[a-zA-ZÀ-ÿñÑ\s]{2,30}$" required>
                    </div>

                    <div class="col col-6">
                        <label class="form-label">Código:</label>
                        <input type="text" autocomplete="off" class="form-control form-control-sm custom-input" placeholder="Código" name="txtCodigo" #txtCodigo="ngModel" [(ngModel)]='AlmacenRQ.codigo' maxlength="30" pattern="^[a-zA-Z0-9À-ÿñÑ\s\-]{2,30}$" required>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col col-2">
                        <label class="form-label">Activo:</label>
                    </div>
                    <div class="col col-10">
                        <p-checkbox name="cbEstatus" #cbEstatus="ngModel" [(ngModel)]="AlmacenRQ.activo" [binary]="true" inputId="cbActivo"></p-checkbox>
                    </div>
                </div>
            </div>

            <div class="row mt-4">
                <div class="col text-end">
                    <button type="button" (click)="onClose()" class="btn btn-sm rounded-button btn-secondary">
                                <i class="fa fa-arrow-left"></i>
                                Regresar
                    </button>
                    <button type="submit" [disabled]="!formNuevoAlmacen.form.valid" class="side-space btn btn-sm rounded-button btn-success">
                        Aceptar
                        <i class="fa fa-check"></i>
                    </button>
                </div>
            </div>
        </form>

    </div>